<template>
  <div
    id="bottom-progress-bar"
    class="bottom-slide-progress-bar"
  >
    <div
      class="slide-progress-bar"
      :style="{
        width: percentProgress
      }"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      activeSlide: (state) => state.slide,
      slidesList: (state) => state.slidesList,
    }),
    percentProgress() {
      const index = this.slidesList.findIndex((item) => {
        return item.id == this.activeSlide.id
      })
      if (index !== -1 && this.slidesList.length) {
        return `${((index + 1) * 100) / this.slidesList.length}%`
      }
      return `${0}%`
    },
  },
  watch: {
    'slide.id': {
      handler() {
        this.getDataProgress()
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['getSlidesAction', 'setSlideIndexAction']),
    getDataProgress() {
      if (!this.activeSlide.id && !this.slides.length) return

      const index = this.slidesList.findIndex((item) => {
        return item.id == this.activeSlide.id
      })

      if (index != -1) {
        this.setSlideIndexAction({
          index,
        })
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.bottom-slide-progress-bar {
  height: 4px;
  width: 100%;
  background-color: #D3D7E1;

  .slide-progress-bar {
    background-color: #313131;
    height: 100%;
    transition: width 0.5s;
  }
}
</style>
